import Cookies from "@/helpers/cookies"
import { pushGa4Event } from "@/helpers/ga4_helper"

const PROMO_COOKIE = "sitewide_promotion"

const setupSitewidePromo = (): void => {
  const promo = document.getElementById("js-sitewide-promo")

  if (!promo) {
    return
  }

  const promoName = promo.dataset.promoName!

  // Presence of element is sufficient to trigger a promo "view"
  pushGa4Event({ event: "view_promotion", promotion_name: promoName })

  // Track promo link clicks
  promo.addEventListener("click", (e: Event) => {
    if ((e.target as HTMLElement).closest("a")) {
      pushGa4Event({ event: "select_promotion", promotion_name: promoName })
    }
  })

  // Handle promo close
  promo.querySelector("[type=button]")!.addEventListener("click", () => {
    promo.hidden = true
    Cookies.setAtUserRequest(PROMO_COOKIE, "hide")
    document.body.style.setProperty("--promo-bar-height", "0px")
  })
}

export { setupSitewidePromo }
